import { useCallback, useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import { type DueRitual, loadDueRituals, localToday } from '@/lib/workspace-rituals';

/** My rituals of the day, done or not; an occurrence changed in place keeps the list as it is. */
export const useDueRituals = () => {
  const [rituals, setRituals] = useState<DueRitual[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const today = localToday();

  const load = useCallback(async () => {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;
    try {
      setRituals(await loadDueRituals(user.id));
      setError(null);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'Les rituels ne sont pas accessibles.');
    }
  }, []);
  useEffect(() => { void load(); }, [load]);

  const replaceOccurrence = useCallback((ritualId: string, occurrence: DueRitual['occurrence']) => {
    setRituals((current) => current?.map((item) => (item.ritual.id === ritualId ? { ...item, occurrence } : item)) ?? null);
  }, []);
  return { rituals, error, today, replaceOccurrence, reload: load };
};
